import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/SignUp';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Payment from './pages/Payment';
import NotFound from './pages/NotFound'; // 404 페이지
import Favorites from './pages/Favorites';
import Spaces from './pages/Space';
import ReservationForm from './pages/test/ReservationForm';
import Checkout from './componets/Payup/Checkout';
import PaymentDetail from './pages/PaymentDetail';
import UploadSpace from './pages/UploadSpace';
import ReservationList from './pages/ReservationList';
import ReservationDetail from './pages/ReservationDetail';
import SpaceDetail from './pages/SpaceDetail';
import { SuccessPage } from './componets/Payup/Success';
import CancelPaymentPage from './pages/CanclePayment';
import {FailPage} from './componets/Payup/Fail';
import AdminReservationList from './pages/admin/EscrowManagement'
import TermsOfService from './pages/TermsOfService';
import MySpaces from './pages/MySpaces';
import MyReservations from './pages/MyReservations';
import MyReservations2 from './pages/Myreservations2';
import UserPaymentHistory from './pages/UserPaymentHistory';
import HostAccountVerify from './pages/HostAccountVerify';
import { HelmetProvider } from 'react-helmet-async';
import GaTracker from './componets/GaTracker';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <GaTracker />
        <Routes>
          <Route path="/" element={<Spaces />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/payment/user" element={<UserPaymentHistory />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/spaces" element={<Spaces />} />
          <Route path="/spaces/:spaceId" element={<SpaceDetail />} />
          <Route path="/spaces/:spaceId/reservation-form" element={<ReservationForm />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/upload-space" element={<UploadSpace />} />
          <Route path="/mypage/spaces" element={<MySpaces/>} />
          <Route path="/mypage/reservations" element={<MyReservations2 />} />
          <Route path="/favorites" element={<Favorites />} />
          <Route path="/page/ReservationList/:spaceId" element={<ReservationList />} />
          <Route path="/page/ReservationDetail/:reservationId" element={<ReservationDetail />} />
          <Route path="/checkout/:reservationId" element={<Checkout/>}/>
          <Route path="/policy/TOS" element={<TermsOfService/>}/>
          <Route path="/payment/:reservationId" element={<PaymentDetail />} />
          <Route path="/payment/success" element={<SuccessPage />} />
          <Route path="/payment/fail" element={<FailPage />} />
          <Route path="/payment/cancle" element={<CancelPaymentPage/>}/>
          <Route path="/admin/ascrow" element={<AdminReservationList/>}/>
          <Route path="/host/account-verify" element={<HostAccountVerify />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;